import type { Bonus, Freespin } from '@/api/common';
import { ACTIVE_BONUS_STAGES } from './constants';

export const isActiveBonus = (bonus: Bonus | Freespin) =>
  ACTIVE_BONUS_STAGES.includes(bonus.stage);

export const getActiveBonuses = (bonuses: Bonus[], freespins: Freespin[]) => {
  const allBonuses = [...bonuses, ...freespins];
  const activeBonuses = allBonuses.filter(isActiveBonus);
  return activeBonuses;
};

const getExpirationDate = (bonus: Bonus | Freespin): Date | null => {
  const dateString = bonus.activatable
    ? bonus.activatableUntil
    : bonus.validUntil;
  return dateString ? new Date(dateString) : null;
};

export const sortBonusesByExpiration = (
  bonuses: (Bonus | Freespin)[]
): (Bonus | Freespin)[] =>
  [...bonuses].sort((a, b) => {
    const dateA = getExpirationDate(a);
    const dateB = getExpirationDate(b);

    if (!dateA) return dateB ? 1 : 0;
    if (!dateB) return -1;

    return dateA.getTime() - dateB.getTime();
  });
